export function isPaymentFeatureDisabledError(error: unknown): boolean {
  const anyError = error as {
    status?: number;
    response?: { status?: number };
    cause?: { status?: number };
  };

  return (
    anyError?.status === 403 ||
    anyError?.response?.status === 403 ||
    anyError?.cause?.status === 403
  );
}

export function hasPaymentFeatureDisabledMarker(
  requiredActions: string[] | null | undefined,
): boolean {
  return Boolean(requiredActions?.includes("GMO_PAYMENT_DISABLED"));
}
